import React from 'react';
import { Prompt, Redirect } from 'react-router-dom';
import ModalEnabled from '../extend/ModalEnabled';
import GroceryList from '../groceryList/GroceryList';
import ApproveGroceryListModal from '../groceryList/ApproveGroceryListModal';
import AddIngredientModal from '../shared/AddIngredientModal';
import BackButton from '../shared/BackButton';
import TextAreaView from '../shared/TextAreaView';
import TextAreaModal from '../shared/TextAreaModal';
import { maskMoney, maskDate } from '../../masks';
import { serviceAPI } from '../../InterfaceAPI/serviceAPI';
import { menuAPI } from '../../InterfaceAPI/menuAPI';
import withSplashMessage from '../splashMessage/withSplashMessage';
import { stringfyServerErrors } from '../../helpers/util';
import withTracker from '../withTracker';
import { get as _get } from 'lodash';

class AdminGroceryList extends ModalEnabled {
  state = {
    groceryList: {},
    allergens: [],
    dietary: [],
    availableCategories: [],
    special_instructions: '',
    isEdit: false,
    isLoading: false,
    unsaved: false,
    redirect_to: false
  };

  renderAllergens() {
    if (
      this.state.allergens.length <= 0 &&
      this.state.other_allergens <= 0 &&
      this.state.dietary <= 0 &&
      _get(this.state, 'special_instructions.length', 0) <= 0
    )
      return;

    // Allergens
    const tags = this.state.allergens.map((item) => item.tag);

    // Other Allergens
    if (this.state.other_allergens) tags.push(this.state.other_allergens);

    // Diet
    const dietTags = this.state.dietary.map((item) => item.tag);

    const list = tags.join(', ');
    const dietList = dietTags.join(', ');

    return (
      <div className="row">
        <div className="row__item">
          <div className="cms__section">
            <div className="cms__bar cms__section-head">
              <div className="cms__bar-left">
                <h3 className="h3">
                  Allergens:{' '}
                  <span className="recipe-price__label--value recipe-price__label--big">
                    <span className="p--red">{list}</span>
                  </span>
                </h3>
                <h3 className="h3">
                  Diet:{' '}
                  <span className="recipe-price__label--value recipe-price__label--big">
                    <span className="p--red">{dietList}</span>
                  </span>
                </h3>
                <h3 className="h3">
                  Special Instructions:{' '}
                  <span className="p">{this.state.special_instructions}</span>
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const {
      groceryList,
      isEdit,
      availableCategories,
      redirect_to,
      allergens,
      dietary
    } = this.state;

    if (redirect_to) return <Redirect to={redirect_to} />;

    return (
      <div className="cms">
        <div className="cms__head cms__head--padding">
          <div className="cms__content">
            <BackButton defaultUrl="/admin/services" />
            <div className="cms__bar">
              <div className="heading-placeolder">
                <h1 className="h2 heading-placeholder__h1">Grocery List</h1>
                <p className="p">
                  {groceryList.approved
                    ? `Approved on ${maskDate(groceryList.approved_at)}`
                    : ''}
                </p>
              </div>
              <div className="cms__bar-ctas">
                {this.renderEditButton()}
                <div
                  className="btn btn--solid-blue"
                  onClick={() => this.openModal('approve')}
                >
                  {groceryList.approved ? 'Update' : 'Approve'}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="cms__body">
          <div className="cms__content">
            {this.renderAllergens()}

            <div className="row">
              <div className="row__item">
                <div className="cms__section">
                  <div className="cms__bar cms__section-head">
                    <div className="cms__bar-left">
                      <h3 className="h3">
                        Estimated Grocery Cost:{' '}
                        <span className="recipe-price__label--value recipe-price__label--big">
                          {maskMoney(groceryList.total || 0)}
                        </span>
                      </h3>
                    </div>
                  </div>
                  <div className="cms__section-body">
                    <GroceryList
                      isEdit={isEdit}
                      groceryList={groceryList.grocery_list_items}
                      updateGroceryList={this.updateGroceryList}
                      availableCategories={availableCategories}
                      allergens={allergens}
                      dietaryPreferences={dietary}
                    />
                    {isEdit ? (
                      <div className="row">
                        <div className="row__item row__item--half">
                          <div
                            className="btn btn--white btn--full-width"
                            onClick={() => this.openModal('add-ingredient')}
                          >
                            Add Product From Library
                          </div>
                        </div>
                        <div className="row__item row__item--half">
                          <div
                            className="btn btn--white btn--full-width"
                            onClick={this.addCustomProduct}
                          >
                            Add Custom Product
                          </div>
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="row__item row__item--half">
                <TextAreaView
                  value={groceryList.notes}
                  openEdit={() => this.openModal('notes')}
                  isEdit={isEdit}
                />
              </div>
            </div>
          </div>
        </div>

        <TextAreaModal
          isOpen={this.isOpen('notes')}
          closeModal={this.closeModal}
          title="Public Notes"
          value={groceryList.notes}
          onSubmit={this.updateNotes}
        />

        <AddIngredientModal
          isOpen={this.isOpen('add-ingredient')}
          closeModal={this.closeModal}
          addIngredient={this.addProduct}
        />

        <ApproveGroceryListModal
          isOpen={this.isOpen('approve')}
          closeModal={this.closeModal}
          approved={groceryList.approved}
          onSubmit={this.handleSubmit}
        />

        <Prompt
          when={this.state.unsaved}
          message="You have unsaved data, are you sure?"
        />
      </div>
    );
  }

  renderEditButton() {
    const copy = this.state.isEdit ? 'Save' : 'Edit';
    return (
      <div className="btn btn--hollow-blue" onClick={this.toggleEdit}>
        {copy}
      </div>
    );
  }

  toggleEdit = () => {
    this.setState({ isEdit: !this.state.isEdit });
  };

  loadGroceryList(id) {
    this.setState({ isLoading: true });
    serviceAPI
      .getGroceryList(id)
      .then((groceryList) => {
        groceryList.grocery_list_items = [
          ...groceryList.grocery_list_items.filter(this.groceryFilter),
        ];
        this.setState({ groceryList, isLoading: false });
      })
      .catch((err) => this.handleErrorLoading(err, id));
  }

  loadAllergens(id) {
    serviceAPI
      .getService(id)
      .then((service) => {
        this.setState({
          allergens: service.client.allergen_tags,
          other_allergens: service.client.other_allergens,
          dietary: service.client.dietary_preference_tags,
          special_instructions: service.client.special_instructions,
        });
      })
      .catch((err) => this.handleErrorLoading(err, id));
  }

  handleErrorLoading = (error, id) => {
    console.log(error);
    const pathname = `/admin/service/${id}`;
    const redirect_to = { pathname };

    const { state } = this.props.location;
    if (state) {
      const { redirect_url, redirect_payload } = state;
      if (redirect_url) {
        redirect_to.pathname = redirect_url;
      }

      if (redirect_payload) redirect_to.state = { ...redirect_payload };
    }
    this.props.addMessage({
      className: 'error',
      message: stringfyServerErrors(error),
    }); // todo: add messaging
    this.setState({ redirect_to, isLoading: false });
  };

  updateNotes = (notes) => {
    this.updateGroceryList({ notes });
  };

  updateGroceryList = (updatedGroceryList) => {
    const groceryList = {
      ...this.state.groceryList,
      ...updatedGroceryList,
    };
    this.setState({ groceryList, openModal: '', unsaved: true });
  };

  addProduct = (product) => {
    const listItem = {
      custom_category: '',
      is_custom: false,
      line_amount: product.paid_price_cents,
      name: product.name,
      notes: '',
      product: product,
      quantity: 1,
    };
    const groceryList = { ...this.state.groceryList };
    groceryList.grocery_list_items.push(listItem);
    this.updateGroceryList(groceryList);
  };

  addCustomProduct = () => {
    const listItem = {
      custom_category: 'Produce',
      is_custom: true,
      line_amount: 0,
      name: '',
      notes: '',
      product: {},
      quantity: 1,
    };
    const groceryList = { ...this.state.groceryList };
    groceryList.grocery_list_items.push(listItem);
    this.updateGroceryList(groceryList);
  };

  handleSubmit = () => {
    const groceryList = { ...this.state.groceryList };
    groceryList.approved = true;
    serviceAPI
      .updateGroceryList(groceryList)
      .then((groceryList) => {
        const redirect_to =
          'state' in this.props.location &&
          this.props.location.state &&
          'redirect_url' in this.props.location.state &&
          this.props.location.state.redirect_url
            ? this.props.location.state.redirect_url
            : false;
        groceryList.grocery_list_items = [
          ...groceryList.grocery_list_items.filter(this.groceryFilter),
        ];
        this.setState({ groceryList, redirect_to, openModal: '' });
      })
      .catch((error) => {
        this.props.addMessage({ className: 'error', msg: error });
        this.setState({ openModal: '' });
      });
  };

  groceryFilter = (item) => item.line_amount > 0 || item.is_custom;

  componentDidMount() {
    this.loadGroceryList(this.props.match.params.id);
    this.loadAllergens(this.props.match.params.id);

    menuAPI
      .getProductCategories()
      .then(({ product_categories }) => {
        const availableCategories = product_categories.map((cat) => {
          return { value: cat.name, label: cat.name };
        });
        this.setState({ availableCategories });
      })
      .catch((error) =>
        this.props.addMessage({
          className: 'error',
          msg: 'Error loading Product Categories',
        })
      );
  }
}
export default withSplashMessage(withTracker(AdminGroceryList));



// WEBPACK FOOTER //
// ./src/components/admin/AdminGroceryList.js